import React, { Component } from 'react'
import styled from 'styled-components'
import { PAGE_URL } from 'config'
import Loading from 'components/Loading'
let checkingLogin

export default class AuthWrapper extends Component {
  constructor() {
    super()
    this.state = {
      iFrameHeight: '0px',
      loaded: false,
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
    clearInterval(checkingLogin)
  }

  componentDidMount() {
    // Listen to simulator messages
    window.addEventListener('message', this.onIframeMessage.bind(this))
  }

  /**
   * Iframe action listener
   * @param {*} e
   */
  /* eslint-disable camelcase */
  onIframeMessage(e) {
    const action = e.data
    if (action === 'userLoggedIn') {
      this.props.getCurrentUser()
    }

    if (action === 'ccAuth') {
      this.setState({ checkingLogin: true })
      checkingLogin = setInterval(() => {
        let token = window.localStorage.getItem('tokenauth')
        let saml_user_data = window.localStorage.getItem('saml_user_data')
        if (token) {
          this.setState({ checkingLogin: false })
          this.props.getCurrentUser()
          clearInterval(checkingLogin)
        }

        if (!token && saml_user_data) {
          this.setState({ checkingLogin: false })
          clearInterval(checkingLogin)
        }
      }, 800)
    }
  }
  /* eslint-enable camelcase */

  amaFailed() {
    this.props.toggler({ opened: false })
    clearInterval(checkingLogin)
    setTimeout(() => {
      this.props.toggler({ opened: true })
    }, 100)
  }

  render() {
    let url = `${PAGE_URL}/authmodal/?iframed`

    if (this.props.isRegister) {
      url = `${url}&register`
    }

    return (
      <WrapperOutside>
        <Wrapper
          id={`auth-frame`}
          src={url}
          onLoad={() => {
            this.setState({ loaded: true })
            this.interval = setInterval(() => {
              const obj = document.getElementById('auth-frame')

              if (obj) {
                const body = obj.contentWindow.document.body
                if (body) {
                  const height = `${obj.contentWindow.document.body.scrollHeight}px`

                  if (height !== this.state.iFrameHeight) {
                    this.setState({
                      iFrameHeight: `${obj.contentWindow.document.body.scrollHeight}px`,
                    })
                  }
                }
              }
            }, 100)
          }}
          height={this.state.iFrameHeight}
          width={this.state.iframeWidth}
          scrolling={0}
        />
        {this.state.checkingLogin && (
          <CheckingLoginWrapper>
            <Loading small noHeight />
            <LoadingText>
              A espera de resposta de autenticação. <br />
              Complete a sua autenticação no site da ama.
            </LoadingText>
            <FailedLink onClick={() => this.amaFailed()}>
              Em caso de falha no processo clique aqui para tentar novamente
            </FailedLink>
          </CheckingLoginWrapper>
        )}
        {!this.state.loaded && (
          <LoadingWrapper>
            <Loading small noHeight />
          </LoadingWrapper>
        )}
      </WrapperOutside>
    )
  }
}

const WrapperOutside = styled.div`
  width: 100%;
  position: relative;
`

const Wrapper = styled.iframe`
  border: 0;
  width: 100%;
  overflow: hidden;
  height: ${({ height }) => height && height}!important;
`

const CheckingLoginWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 300px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`
const LoadingText = styled.div`
  color: #fff;
  text-align: center;
`
const FailedLink = styled.div`
  text-align: center;
  color: #fff;
  text-decoration: underline;
  margin-top: 10px;
  font-size: 14px;
  cursor: pointer;
`

const LoadingWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 300px;
`



// WEBPACK FOOTER //
// ./src/containers/AuthWrapper/index.js